// Каталог (К-04) и курс (К-05): по умолчанию — ступень ребёнка (FR-LIB-02), курсы — упорядоченные сценарии (FR-LIB-04).
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { ScenarioCard } from "../components/ScenarioCard.tsx";
import { TopBar } from "../components/Shell.tsx";
import { STAGES, playedScenarios } from "../lib/content/catalog.ts";
import type { Stage } from "../lib/db.ts";
import { activeChild, useApp } from "../state/app.ts";
import { useChildEvents } from "./Today.tsx";
import { t } from "../i18n/ru.ts";

export function Catalog() {
  const nav = useNavigate();
  const content = useApp((s) => s.content);
  const child = activeChild();
  const [stage, setStage] = useState<Stage | "all">(child?.stage ?? "all");
  const events = useChildEvents(child?.id);
  if (!content) return <p className="page">{t.common.loading}</p>;
  const played = playedScenarios(events);
  const courses = content.courses.filter((c) => !content.hidden.has(c.course.id) && (stage === "all" || c.course.stages.includes(stage)));
  return (
    <div className="page">
      <TopBar title={t.catalog.title} />
      <div className="segmented" role="tablist" aria-label={t.catalog.stage}>
        <button role="tab" aria-selected={stage === "all"} className={stage === "all" ? "is-active" : ""} onClick={() => setStage("all")}>
          {t.catalog.all}
        </button>
        {STAGES.filter((s) => content.courses.some((c) => c.course.stages.includes(s))).map((s) => (
          <button key={s} role="tab" aria-selected={stage === s} className={stage === s ? "is-active" : ""} onClick={() => setStage(s)}>
            {content.dictionaries.stages[s]?.name ?? s}
          </button>
        ))}
      </div>
      {courses.map((c) => {
        const scen = c.scenarios.filter((s) => !content.hidden.has(s.scenario.id));
        return (
          <section key={c.course.id} className="course-block">
            <Link to={`/course/${encodeURIComponent(c.course.id)}`} className="course-block__head">
              <h2>{c.course.title}</h2>
              <span className="muted">
                {c.course.summary} · {t.catalog.scenarios(scen.length)}
              </span>
            </Link>
            <div className="grid">
              {scen.map((s) => (
                <ScenarioCard key={s.scenario.id} s={s} played={played.has(s.scenario.id)} onOpen={() => nav(`/scenario/${encodeURIComponent(s.scenario.id)}`)} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}

export function CourseScreen() {
  const { id = "" } = useParams();
  const nav = useNavigate();
  const content = useApp((s) => s.content);
  const child = activeChild();
  const events = useChildEvents(child?.id);
  const c = content?.courses.find((x) => x.course.id === id);
  if (!content || !c) return <p className="page">{t.player.notFound}</p>;
  const played = playedScenarios(events);
  return (
    <div className="page">
      <TopBar title={c.course.title} back={() => nav(-1)} />
      <p>{c.course.summary}</p>
      <ol className="course-list">
        {c.scenarios
          .filter((s) => !content.hidden.has(s.scenario.id))
          .map((s) => (
            <li key={s.scenario.id}>
              <ScenarioCard s={s} played={played.has(s.scenario.id)} onOpen={() => nav(`/scenario/${encodeURIComponent(s.scenario.id)}`)} />
            </li>
          ))}
      </ol>
      {c.exercises.length ? (
        <>
          <h2 className="section-title">{t.catalog.exercises}</h2>
          <ul className="link-list">
            {c.exercises.map((e) => (
              <li key={e.id}>
                <Link to={`/exercise/${encodeURIComponent(e.id)}`}>{e.title}</Link>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
}
